import React, { useState, useEffect } from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import "../../../../Roles and Permissions/Filters/Scrollbar.css";
import { get } from "../../../../../../utils/api";
const UnitFilter = ({ selectedUnits = [], setSelectedUnits, url, errors }) => {
  const [facilities, setFacilities] = useState([]);

  useEffect(() => {
    // Fetch all Facilities from the backend
    const fetchFacilities = async () => {
      try {
        const response = await get(url);
        // Extract unique Facility names from the user data
        console.log(response.data);
        const uniqueFacilities = [
          ...new Set(response.data.data.map((item) => item.unit)),
        ];
        setFacilities(uniqueFacilities);
        console.log("uniqueFacilities", uniqueFacilities);
      } catch (error) {
        console.error("Error fetching Facilities:", error);
      }
    };

    fetchFacilities();
  }, []);




  const handleFacilityChange = (event) => {
    const selectedEqupments = event.target.value;
 
    if (event.target.checked) {
      setSelectedUnits([...selectedUnits, selectedEqupments]);
    } else {
      setSelectedUnits(
        selectedUnits.filter((country) => country !== selectedEqupments)
      );
    }
  };

  return (
    <Box sx={{ m: "5%", mt: 0 }}>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: "bold",
          marginBottom: "30px",
          // m:"10%"
        }}
      >
        Unit
      </Typography>
      <Box className="scrollable-container">
        {facilities.length > 0 ? (
          facilities.map((Unit, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  value={Unit}
                  checked={selectedUnits?.includes(Unit)} // Ensure selectedEqupments is an array
                  onChange={handleFacilityChange}
                />
              }
              label={Unit}
            />
          ))
        ) : (
          <Typography>No Unit of Heat found</Typography>
        )}
      </Box>
      {errors && (
        <Typography variant="body2" color="#D34040" sx={{ mt: 2 }}>
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default UnitFilter;
